module.exports = __webpack_public_path__ + "img/finance_detail_1.18754b9d.svg";